import { gql } from "apollo-angular";

export const  STORIES_CB = gql`
  fragment STORIES_CB on StoriesCb {
    config1
    content1
    quoteText1
    quoteDesc1
    quoteAuthor1
    mediaImg1Collection {
      items {
        sys {
          id
        }
        url
        description
      }
    }
    ytId1
    mediaAlignment1
    additionalFields
    config2
    content2
    quoteText2
    quoteDesc2
    quoteAuthor2
    mediaImg2Collection {
      items {
        sys {
          id
        }
        url
        description
      }
    }
    ytId2
    mediaAlignment2
    additionalFields2
    config3
    content3
    quoteText3
    quoteDesc3
    quoteAuthor3
    mediaImg3Collection {
      items {
        sys {
          id
        }
        url
        description
      }
    }
    ytId3
    mediaAlignment3
    additionalFields3
    config4
    content4
    quoteText4
    quoteDesc4
    quoteAuthor4
    mediaImg4Collection {
      items {
        sys {
          id
        }
        url
        description
      }
    }
    ytId4
    mediaAlignment4
    additionalFields4
    config5
    content5
    quoteText5
    quoteDesc5
    quoteAuthor5
    mediaImg5Collection {
      items {
        sys {
        id
      }
        url
        description
      }
    }
    ytId5
    mediaAlignment5
    additionalFields5
  }`;